import {
  getUserFolders,
  getFolderDetails,
  getUserResourceFolders,
  createFolder,
  shareFolder,
  getUsersFromSchoolWithoutFolderInfo,
  getUserPermissions,
  orderFolderResources,
  updateFolderDescription
} from '../../services/FolderService'
import { isError } from '../../utils/api'
import router, { routes } from '../../router'

export default {
  state: {
    folders: [],
    folderDetail: {},
    foldersLoading: false,
    resourceFolders: [],
    resourceFoldersOwned: [],
    resourceFoldersOwnedEdition: [],
    resourceFoldersShared: [],
    resourceFoldersSharedEdition: [],
    invalidNameFolder: false,
    availableUsersToShareFolder: [],
    userPermissions: []
  },

  mutations: {
    setFolders(state, folders) {
      state.folders = folders
    },
    updatePermission(state, { userId, permission }) {
      state.userPermissions = state.userPermissions.map(user => user.user.userId === userId ? ({ ...user, permission }) : user)
    },
    deletePermission(state, id) {
      state.userPermissions = state.userPermissions.filter(user => user.user.userId !== id)
    },
    addFolder(state, folder) {
      state.resourceFolders.push({
        folderId: folder.id,
        folderName: folder.name,
        inFolder: true
      })
    },
    setResourceFolders(state, folders) {
      state.resourceFoldersOwned = folders.owned
      state.resourceFoldersShared = folders.shared
    },
    clearResourceFolders(state) {
      state.resourceFoldersOwned = []
      state.resourceFoldersShared = []
      state.resourceFoldersOwnedEdition = []
      state.resourceFoldersSharedEdition = []
    },
    setFolder(state, folder) {
      state.folderDetail = folder
    },
    setLoadingFolders(state, status) {
      state.foldersLoading = status
    },
    updateResourceFolders(state, data) {
      if (data.isOwner) {
        const foundIndex = state.resourceFoldersOwned.findIndex(folder => folder.folderId === data.folderId)
        state.resourceFoldersOwned[foundIndex].inFolder = !state.resourceFoldersOwned[foundIndex].inFolder
        const wasEdited = state.resourceFoldersOwnedEdition.find(folder => folder.folderId === data.folderId)
        if (wasEdited) state.resourceFoldersOwnedEdition.map(folder => folder.folderId === data.folderId ? ({ ...folder, inFolder: !folder.inFolder }) : folder)
        else state.resourceFoldersOwnedEdition.push(state.resourceFoldersOwned[foundIndex])
      } else {
        const foundIndex = state.resourceFoldersShared.findIndex(folder => folder.folderId === data.folderId)
        state.resourceFoldersShared[foundIndex].inFolder = !state.resourceFoldersShared[foundIndex].inFolder
        const wasEdited = state.resourceFoldersSharedEdition.find(folder => folder.id === data.folderId)
        if (wasEdited) state.resourceFoldersSharedEdition.map(folder => folder.folderId === data.folderId ? ({ ...folder, inFolder: !folder.inFolder }) : folder)
        else state.resourceFoldersSharedEdition.push(state.resourceFoldersShared[foundIndex])
      }
    },
    setErrorName(state, status) {
      state.invalidNameFolder = status
    },
    setAvailableUsersToShareFolder(state, payload) {
      state.availableUsersToShareFolder = payload
    },
    setUserPermissions(state, payload) {
      state.userPermissions = payload
    }
  },

  actions: {
    clearError({ commit }, payload) {
      commit('setErrorName', payload)
    },
    createAndToggle({ commit }, payload) {
      commit('show', { element: 'fullPageLoader' })
      commit('setLoadingFolders', true)
      return createFolder(payload.folder).then(response => {
        commit('setErrorName', false)
        commit('addFolder', response.data)
        commit('hide', { element: 'fullPageLoader' })
        commit('setLoadingFolders', false)
      }).catch(() => {
        commit('setErrorName', true)
        commit('hide', { element: 'fullPageLoader' })
        commit('setLoadingFolders', false)
      })
    },
    toggleResourceFolders({ commit }, payload) {
      commit('updateResourceFolders', payload)
    },
    hydrateFolders({ commit }, payload = { owner: true }) {
      commit('show', { element: 'fullPageLoader' })
      commit('setLoadingFolders', true)
      getUserFolders(payload).then(response => {
        commit('setFolders', response.data)
        commit('hide', { element: 'fullPageLoader' })
        commit('setLoadingFolders', false)
      })
    },
    hydrateResourceFolders({ commit }, { id, locale }) {
      commit('show', { element: 'fullPageLoader' })
      commit('setLoadingFolders', true)
      getUserResourceFolders({ id, locale }).then(response => {
        commit('setResourceFolders', response.data)
        commit('hide', { element: 'fullPageLoader' })
        commit('setLoadingFolders', false)
      })
    },
    clearResourceFolders({ commit }) {
      commit('clearResourceFolders')
    },
    hydrateUserPermissions({ commit }, payload) {
      commit('setLoadingFolders', true)
      getUserPermissions(payload).then(response => {
        commit('setUserPermissions', response.data.userPermissions)
        commit('setLoadingFolders', false)
      })
    },
    updatePermission({ commit }, data) {
      commit('updatePermission', data)
    },
    deletePermission({ commit }, id) {
      commit('deletePermission', id)
    },
    cleanPermissions({ commit }) {
      commit('setUserPermissions', [])
    },
    async getFolderDetails({ commit }, payload) {
      commit('show', { element: 'fullPageLoader' })
      const response = await getFolderDetails(payload).catch(e => e.response)
      if (isError(response.status)) {
        router.push({ name: routes.notFound })
      } else {
        commit('setFolder', response.data)
      }
      commit('hide', { element: 'fullPageLoader' })
    },
    async getAvailableUsersToShareFolder({ commit }, filters = {}) {
      const response = await getUsersFromSchoolWithoutFolderInfo(filters)
      if (!isError(response.status)) {
        commit('setAvailableUsersToShareFolder', response.data)
      }
    },
    clearAvailableUsersToShareFolder({ commit }) {
      commit('setAvailableUsersToShareFolder', [])
    },
    async shareFolder({ commit }, payload) {
      const response = await shareFolder(payload.id, payload.users, payload.locale).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      return successfulRequest
    },
    async orderFolderResources({ commit }, { folderId, resources }) {
      const response = await orderFolderResources({ folderId, resources }).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      return successfulRequest
    },
    async updateFolderDescription({ commit }, { folderId, description }) {
      const response = await updateFolderDescription({ folderId, description }).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      return successfulRequest
    }
  }
}
